/** Round `n` (a 0..1 ratio) to a whole-percent string, e.g. `0.7` → `"70%"`. */
export function formatPercent(n: number): string {
  return `${Math.round(n * 100)}%`
}

/** Same as `formatPercent`, but for a nullable rate (`null` → `"—"`). */
export function formatPercentOrDash(n: number | null): string {
  return n === null ? '—' : formatPercent(n)
}

/** Format a BRL amount, e.g. `9600` → `"R$ 9.600,00"`. */
export function formatCurrencyBRL(n: number): string {
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

/**
 * Format a USD amount, e.g. `1.2345` → `"US$ 1,23"` — Story 10.6
 * (2026-07-30) — custo de IA/WhatsApp é estimado em USD (mesma moeda de
 * `estimatedCostUsd`), diferente do faturamento de vendas que é em BRL.
 */
export function formatCurrencyUSD(n: number): string {
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'USD' })
}

/**
 * Relative timestamp, e.g. "5 min atrás", "2 h atrás", "3 d atrás". Falls
 * back to a full locale timestamp past 30 days, and to the raw ISO string on
 * a malformed input. Extracted from `AuditLog.tsx` (2026-07-30, Story 10.7)
 * — same formatting need for "Últimas Interações da IA".
 */
export function formatRelativeTime(iso: string): string {
  const dt = new Date(iso)
  if (Number.isNaN(dt.getTime())) return iso
  const diffMs = Date.now() - dt.getTime()
  const sec = Math.floor(diffMs / 1000)
  if (sec < 60) return 'agora'
  const min = Math.floor(sec / 60)
  if (min < 60) return `${min} min atrás`
  const hr = Math.floor(min / 60)
  if (hr < 24) return `${hr} h atrás`
  const day = Math.floor(hr / 24)
  if (day < 30) return `${day} d atrás`
  return dt.toLocaleString('pt-BR')
}
